import { handleHtmlClick } from '../utils/ktcUtils';

export default function Table({ tbodyData }) {
  const theadData = tbodyData?.length ? Object.keys(tbodyData[0]) : [];

  const hasHtml = (value) => {
    return typeof value === 'string' && /<[^>]+>/.test(value);
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped table-hover align-middle">
        <thead className="table-dark">
          <tr>
            {theadData.map((heading) => (
              <th key={heading}>{heading}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {tbodyData?.length ? (
            tbodyData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {theadData.map((key) => (
                  <td key={key}>
                    {hasHtml(row[key]) ? (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: row[key],
                        }}
                        onClick={handleHtmlClick}
                      />
                    ) : (
                      row[key]
                    )}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={theadData.length} className="text-center text-muted">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
